<template>
    <v-row class="pa-3">
        <v-col cols="12" v-if="loadingAll">
            <loading-spinner/>
        </v-col>
        <v-col cols="12" v-else-if="options.length === 0">
            <v-alert type="warning" dense class="caption-heavy" border="left">
                Aún no se agregan examenes
            </v-alert>
        </v-col>
        <template v-else>
            <template v-if="listMode">
                <v-col cols="12">
                    <v-checkbox
                        v-model="isAll"
                        label="Todo"
                        @click="selectedAll"
                        hide-details dense
                    />
                </v-col>
                <v-col cols="12" class="py-0">
                    <v-divider/>
                </v-col>
                <v-col cols="12" v-for="(option,i) in options" :key="i">
                    <v-row>
                        <v-col cols="2" align="center" class="py-1 pr-0">
                            <v-checkbox
                                v-model="model"
                                :value="valueOption(option)"
                                hide-details dense
                            ></v-checkbox>
                        </v-col>
                        <template v-if="option.isPack">
                            <v-col cols="10" class="py-1 px-0">
                                <v-expansion-panels flat accordion :value="i === 0 ? 0 : null">
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <v-row>
                                                <v-col cols="12" class="pa-0">
                                                    <div class="body-heavy primary-color">
                                                        {{ option.name }}
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" class="pa-0">
                                                    <div class="mt-1 caption-light grey-color">
                                                        {{ option.examsQuantity }} examenes
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <div v-if="option.description" class="small-light pb-5">
                                                {{ option.description }}
                                            </div>
                                            <v-row v-for="(exam,i) in option.exams" :key="i">
                                                <v-col cols="12" md="7"
                                                       class="caption-heavy primary-color py-1 text-truncate">
                                                    {{ i + 1 }}- {{ exam.name }}
                                                </v-col>
                                                <v-col cols="12" md="5"
                                                       class="small-light grey-color py-1 text-truncate">
                                                    {{ exam.preparation.name }}
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </template>
                        <template v-else>
                            <v-col cols="9">
                                <div class="ml-1 body-heavy primary-color">
                                    {{ option.name }}
                                </div>
                                <div class="ml-1 mt-1 caption-light grey-color">
                                    {{ optionDescription(option) }}
                                </div>
                            </v-col>
                        </template>
                        <v-col cols="12" class="py-0">
                            <v-divider/>
                        </v-col>
                    </v-row>
                </v-col>
            </template>
            <template v-else>
                <v-col cols="12" v-if="withAllOption" class="py-0">
                    <v-checkbox
                        v-model="isAll"
                        label="Seleccionar todo"
                        @click="selectedAll"
                        hide-details dense
                    />
                </v-col>
                <v-col cols="12" md="6" lg="4" xl="3" v-for="(option,i) in options" :key="i" class="py-0">
                    <v-checkbox
                        class="text-truncate"
                        v-model="model"
                        :label="option.name"
                        :value="valueOption(option)"
                        hide-details dense
                    />
                </v-col>
            </template>
            <v-col cols="12" v-if="details">
                <VMessages :value="errorBucket" color="error" class="mt-1"/>
            </v-col>
        </template>
    </v-row>
</template>

<script>
import LoadingSpinner from "@/components/common/LoadingSpinner";
import {VInput} from "vuetify/lib/components";
import httpService from "@/services/httpService";

export default {
    name: "ExamsPicker",
    extends: VInput,
    components: {LoadingSpinner},
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        rules: {
            type: Array,
            default: () => [],
        },
        details: {
            type: Boolean,
            default: false,
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        listMode: {
            type: Boolean,
            default: false,
        },
        examsOptions: {
            type: Array,
            default: null
        },
        withPacks: {
            type: Boolean,
            default: false,
        },
        withDescription: {
            type: Boolean,
            default: false,
        },
        noDiscountPacks: {
            type: Boolean,
            default: false,
        },
        withAllOption: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            model: [],
            options: [],
            loadingExams: false,
            loadingPacks: false,
            isAll: false,
        }
    },
    computed: {
        loadingAll(vm = this) {
            if (vm.withPacks) return vm.loadingPacks
            return vm.loadingExams
        }
    },
    async mounted() {
        const vm = this
        await vm.loadInitialData()
    },
    methods: {
        async loadInitialData() {
            const vm = this
            if (!vm.withPacks) {
                await vm.loadExams()
            } else {
                await vm.loadPacks()
            }
            vm.setDefaults()
        },
        setDefaults() {
            const vm = this
            if (vm.value) vm.model = vm.value
        },
        async loadExams() {
            const vm = this
            vm.loadingExams = true
            vm.options = []

            if (vm.examsOptions && vm.examsOptions.length > 0) {
                vm.options = vm.examsOptions
                return vm.loadingExams = false
            }

            let response = await httpService.get(`laboratory/${vm.currentEntityId}/exams`)
            vm.options = response.data.exams

            vm.loadingExams = false
        },
        async loadPacks() {
            const vm = this
            vm.loadingPacks = true
            let response = await httpService.get(`laboratory/${vm.currentEntityId}/packs`)

            vm.options = response.data.packs.map(pack => ({
                ...pack,
                examsQuantity: pack.exams.length,
                isPack: true,
            }))

            vm.loadingPacks = false
        },
        valueOption(option) {
            const vm = this
            return vm.returnObject ? option : option.id
        },
        selectedAll() {
            const vm = this
            if (vm.isAll) {
                vm.model = vm.returnObject ? vm.options : vm.options.map(option => option.id)
            } else {
                vm.model = []
            }
        },
        packPrice(pack) {
            if(!pack?.discount || this.noDiscountPacks) return pack.price
            return Number(pack.price * ((100 - pack.discount) / 100)).toFixed(0)
        },
        optionDescription(option) {
            const vm = this
            if(vm.withDescription) return option.description || ''
            return option.preparation.name
        }
    },
    watch: {
        value() {
            this.setDefaults()
        },
        model(val) {
            this.isAll = this.listMode && val.length === this.options.length
            this.$emit('change', val)
        },
        examsOptions() {
            this.loadExams()
        },
        currentEntityId(val) {
            if (val) this.loadInitialData()
        }
    }
}
</script>

<style scoped>

.container-tag {
    position: relative;
    overflow: hidden;
    text-align: right;
    padding-right: 20px;
}

.discount-tag {
    position: absolute;
    background: #8BC53F;
    width: 60px;
    left: -18px;
    top: 5px;
    padding: 2px;
    text-align: center;
    color: #FFFFFF;
    transform: matrix(0.71, -0.79, 0.63, 0.71, 0, 0);
}

</style>